import axios from 'axios';
import { getItem } from '../utils/localStorage';
import {
  authMe,
  notificationsPath,
  readNotificationsPath,
  unReadNotificationCountPath,
} from '../utils/endpoints';
import axiosInstance from '../helpers/interceptor';

export const fetchNotifications = async (notificationParams) => {
  const userData = getItem('user');
  const queryString = new URLSearchParams(notificationParams).toString();
  const apiUrl = `${notificationsPath}?${queryString}`;
  if (!userData) {
    return { data: [] };
  }
  if (navigator.onLine) {
    return axiosInstance.get(apiUrl);
  } else {
    return { data: [] };
  }
};

export const updateNotifications = async (notificationId) => {
  const { accessToken } = getItem('user');
  return axios.put(`${readNotificationsPath}/${notificationId}`, undefined, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

export const authMeRes = async () => {
  const sessionId = getItem('sessionId');
  let apiUrl = authMe;
  // Append both together (or neither): the backend rejects isMultiLogin without a sessionid.
  if (sessionId) {
    apiUrl += `&isMultiLogin=true&sessionid=${encodeURIComponent(sessionId)}`;
  }
  return axiosInstance.get(apiUrl);
};

export const unReadNotificationCount = async () => {
  return axiosInstance.get(unReadNotificationCountPath);
};
